import { ActiveFilter } from "./Filters/types";
import { removeEmptyStrings } from "./Filters/utils";
import { RequestStatus } from "./types";

export const activeFiltersToURLParams = (filters: ActiveFilter[]) => {
  return `&${filters
    .map((filter) => {
      if (filter.activeFilters.filter(removeEmptyStrings).length !== 0) {
        return filter.activeFilters
          .map(
            (innerFilter) => `${filter.name}=${encodeURIComponent(innerFilter)}`
          )
          .join("&");
      }
    })
    .join("&")}`;
};

export const omit = (obj: any, ...props: any) => {
  const result = { ...obj };
  props.forEach((prop: any) => {
    delete result[prop];
  });
  return result;
};

// export const omit = <T, K extends keyof T>(obj: T, prop: K): Exclude<T, K> => {
//   const result = { ...obj };
//   delete result[prop];

//   return result;
// };

export const isEmpty = <T,>(
  value: T | null | undefined
): value is null | undefined => {
  return (
    value === undefined ||
    value === null ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
};

export const getURLSearch = () => {
  if (window.location.search !== "") {
    const arr = window.location.href.split("?");
    return arr[1];
  }

  return "";
};

export const isPending = (status: RequestStatus | null): boolean => {
  return status === RequestStatus.LOADING;
};

export const isError = (status: RequestStatus | null): boolean => {
  return status === RequestStatus.ERROR;
};

export const isSuccess = (status: RequestStatus | null): boolean => {
  return status === RequestStatus.SUCCESS;
};

export const BGN_PER_EUR = 1.95583;

export const roundMoney = (price: number) => Number(Number(price).toFixed(2));

export const toBGN = (price: number) => {
  return roundMoney(price * BGN_PER_EUR);
};

export const toEuroNumber = (price: number | string) => {
  const value = Number(price);
  return Number.isFinite(value)
    ? roundMoney(value / BGN_PER_EUR)
    : undefined;
};

export const toEuro = (price: number | string) => {
  const value = toEuroNumber(price);
  return value === undefined ? "" : value.toFixed(2);
};

export const resolveEuroPrice = (
  priceBgn: number | string,
  priceEur?: number | string | null
) => {
  const storedEuro = Number(priceEur);
  if (priceEur !== undefined && priceEur !== null && Number.isFinite(storedEuro)) {
    return roundMoney(storedEuro);
  }

  return toEuroNumber(priceBgn) ?? 0;
};

export const formatEuro = (
  priceBgn: number | string,
  priceEur?: number | string | null
) => resolveEuroPrice(priceBgn, priceEur).toFixed(2);

export const formatBgn = (price: number | string) => {
  const value = Number(price);
  return Number.isFinite(value) ? value.toFixed(2) : "0.00";
};
